import React from "react";
import { Button } from "components";
import { DotsIcon } from "../../../icons";
import ThemeIcon from "../themes/cards/icon.svg";
import { random } from "../../comms/appeal";

import "./index.scss";

const PlaceholderStoreCard = () => {

    return <div className="store-card">

        <div className="store-card-image">
            <img src={ThemeIcon} alt="" className="preview" />
        </div>

        <div className="store-card-footer">
            <div>
                <div className="store-card-footer-name">
                    <div className="skeleton skeleton4" style={{ height: 17, width: random(70, 120) }} />
                </div>
                <div className="store-card-footer-version">
                    <div className="skeleton skeleton2" style={{ height: 16, width: random(70, 120) }} />
                </div>
            </div>

            <div className="d-flex">
                <Button size="large">
                    Add to library
                </Button>
                <Button variant="secondary" size="large" square className="ml-3">
                    <DotsIcon />
                </Button>
            </div>
        </div>
    </div>
}

export default PlaceholderStoreCard;
